/* istanbul ignore file */
import { httpClient } from "@/lib/http-client/http-client";
import { SupplierInviteRequest ,
    SupplierHashRequest,
    SupplierRegisterRequest,
    SupplierAnonymouseSignInRequest,
    SupplierSendAnswerRequest,
    GetSupplierAndAIAnswersRequest
} from "../interface/requests/suplier-request";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { GetSupplierAndAIAnswersResponse, SupplierAnonymouseSignInResponse, SupplierCategoriesResponse, SupplierCompleteResponse, SupplierHashResponse, SupplierInviteResponse, SupplierRegisterResponse, SupplierSendAnswerResponse } from "../interface/responses/suplier-response";
import { IBaseResponse } from "../interface/responses/IBaseResponse";

class SupplierService {
    private supplierAndAIAnswersInFlight = new Map<
        string,
        Promise<IBaseResponse<GetSupplierAndAIAnswersResponse>>
    >();
    public async supplierInvite(request: SupplierInviteRequest) {
        const response = await httpClient.post<SupplierInviteResponse>(API_ROUTES.Supplier.invite, request);
        return response;
    }
    public async supplierHash(request: SupplierHashRequest) {
        const response = await httpClient.get<SupplierHashResponse>(API_ROUTES.Supplier.hash(request.hash));
        return response;
    }
    public async supplierRegister(request: SupplierRegisterRequest) {
        const response = await httpClient.patch<SupplierRegisterResponse>(API_ROUTES.Supplier.register(request.supplierId), request);
        return response;
    }
    public async supplierAnonymouseSignIn(request: SupplierAnonymouseSignInRequest) {
        const response = await httpClient.post<SupplierAnonymouseSignInResponse>(API_ROUTES.Auth.SigninAnonymous, request);
        return response;
    }
    public async supplierSendAnswer(request: SupplierSendAnswerRequest) {
        const response = await httpClient.post<SupplierSendAnswerResponse>(API_ROUTES.Supplier.sendAnswer, request);
        return response;
    }
    public async supplierComplete(supplierId: string) {
        const response = await httpClient.put<SupplierCompleteResponse>(API_ROUTES.Supplier.complete, {
            supplierId: supplierId
        });
        return response;
    }
    public async getSupplierAndAIAnswers(request: GetSupplierAndAIAnswersRequest) {
        const requestKey = `${request.specificationId}:${request.productId}`;
        const inFlightRequest = this.supplierAndAIAnswersInFlight.get(requestKey);

        if (inFlightRequest) {
            return inFlightRequest;
        }

        const requestPromise = httpClient
            .get<GetSupplierAndAIAnswersResponse>(
                API_ROUTES.Supplier.getSupplierAndAIAnswers(
                    request.specificationId,
                    request.productId
                )
            )
            .finally(() => {
                this.supplierAndAIAnswersInFlight.delete(requestKey);
            });

        this.supplierAndAIAnswersInFlight.set(requestKey, requestPromise);
        return requestPromise;
    }

    public async getSupplierCategories(hash: string) {
        const response = await httpClient.get<SupplierCategoriesResponse>(API_ROUTES.Supplier.categories(hash));
        return response;
    }
}

export const supplierService = new SupplierService();
export default SupplierService;
